export default __webpack_public_path__ + "static/media/resume.83865c30.pdf";